import { createModule } from '../modules';

const SERVER_MESSAGE_MARKER = '@@FROM_SERVER';

export class StateSynchronizer extends createModule('state') {
  constructor(syncClient) {
    super(syncClient);

    this.syncClient = syncClient;

    this._configurations = [];

    this.packetHandlers = {
      REDUX_ACTION: 'onRemoteAction',
    };
  }

  get configurations() {
    return this._configurations;
  }

  set configurations(values) {
    this._configurations = values;

    this.syncClient.rooms.set(values.map((configuration) => configuration.room));
  }

  get middleware() {
    return (store) => (next) => (action) => {
      if (store !== this.store) {
        // TODO: handle store mismatch
      }

      if (this.syncClient.socket.readyState === WebSocket.OPEN) {
        this.sendLocalAction(action);
      }

      return next(action);
    };
  }

  sendLocalAction(action) {
    if (action[SERVER_MESSAGE_MARKER]) return;

    for (const configuration of this.configurations) {
      if (configuration.synchronizedActions.includes(action.type)) {
        this.syncClient.sendPacket(configuration.room, 'REDUX_ACTION', action);
      }
    }
  }

  onRemoteAction({ payload: action }) {
    for (const configuration of this.configurations) {
      if (configuration.synchronizedActions.includes(action.type)) {
        action[SERVER_MESSAGE_MARKER] = true;

        this.store.dispatch(action);
      }
    }
  }
}

export function isRemoteAction(action) {
  return action[SERVER_MESSAGE_MARKER] === true;
}
